package fr.manyverse.app.infrastructure.filepicker

import androidx.compose.runtime.Composable
import io.github.vinceglb.filekit.PlatformFile
import io.github.vinceglb.filekit.dialogs.FileKitDialogSettings

@Composable
internal actual fun rememberPickerDialogSettings(content: PickerContent, title: String): FileKitDialogSettings =
    FileKitDialogSettings.createDefault()

internal actual fun pickerInitialDirectory(content: PickerContent): PlatformFile? = null
